/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable max-len */
import { ChangeDetectorRef, Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import _ from 'lodash';
import { FileLikeObject, FileUploader, FileUploaderOptions } from 'ng2-file-upload';
import { BehaviorSubject, Subscription } from 'rxjs';
import { BadgeOptions } from '../badge/badge.interface';
import { FilePlaceholderOptions } from '../file-placeholder/file-placeholder.interface';
import { FileData } from './file-uploader.interface';
import { FileUploaderService } from './file-uploader.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss']
})
export class FileUploaderComponent implements OnInit, OnDestroy {
  @Input() options: FileData;

  upload_url: string = '';
  response: any;
  displayedColumns: Array<string> = ['position', 'file_name', 'size', 'progress', 'actions'];
  dataSource = new BehaviorSubject([]);
  allowed_file_type: Array<string> = [];
  final_response: Array<any> = [];
  file_name: string;
  preview_data: Array<any> = [];
  preview_data_count: number = 0;
  init_flag: boolean = true;
  companyPolicy: any = null;
  disableUpload: boolean = false;
  fileUploadedFor: FileData['uploadFileFor'] = 'ATTACHMENT';

  public uploader: FileUploader;
  previewFileSubscription: Subscription;
  selectedVisibilityDropdown: boolean = false;
  selectedUserVisibility: boolean = false;
  userVisibilities: any = [
    {
      'label': 'notes.panel.visibility.public',
      'value': true
    },
    {
      'label': 'notes.panel.visibility.internal',
      'value': false
    },
  ]

  constructor(
    public dialogRef: MatDialogRef<FileUploaderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _changeDetectorRef: ChangeDetectorRef,
    private _FileUploaderService: FileUploaderService,
    private _utilityService: UtilityService,
    private _toast: HotToastService,
    private _localStorageService: LocalStorageService,
    private translateService: TranslateService,
  ) {
    this.companyPolicy = this._utilityService.companyPolicy;
    this.allowed_file_type = this._utilityService.basicSupportedFileTypes;
    this.upload_url = `${this._localStorageService.baseUrl}/misc/upload`;
  }

  getPlaceholderOptions(attachment: any, showCloseIcon: boolean, showDownloadIcon: boolean): FilePlaceholderOptions {
    return {
      fileName: attachment.attachment_name ?? 'Untitled',
      fileSize: attachment.attachment_size,
      fileType: this._utilityService.getAttachmentTypeEnum(this._utilityService.getAttachmentExtension(attachment.attachment_path)),
      fileLink: attachment.attachment_path,
      showCloseIcon: showCloseIcon,
      showDownloadIcon: showDownloadIcon
    };
  }

  getPreviewCountOptions(): BadgeOptions {
    const badgeOption: BadgeOptions = {
      type: 'PRIMARY',
      displayKey: this.preview_data.length.toString(),
      displayName: this.preview_data.length,

    };
    return badgeOption;
  }

  fileDrop(): void {
    this._FileUploaderService.onUploadStarted.next(this.uploader);
    if (this.init_flag) {
      if (this.preview_data.length > 0) {
        this.preview_data_count = this.preview_data.length;
      } else {
        this.preview_data_count = 0;
      }
      this.init_flag = false;
    }

    if (this.uploader?.queue?.length > 0) {
      this.dataSource.next(this.uploader.queue);
      this._changeDetectorRef.detectChanges();
    }
  }

  submitClicked(): void {
    this._FileUploaderService.onSubmitClicked.next('Event Emitted');
    this.dialogRef.close(true);
  }

  // eslint-disable-next-line @typescript-eslint/ban-types
  getProgress(width): Object {
    return {
      'width': width + '%'
    };
  }

  removeFile(index): void {
    this.uploader.queue[index].remove();
    if (this.preview_data_count > 0) {
      this.preview_data.splice(this.preview_data_count + index, 1);
    } else {
      this.preview_data.splice(index, 1);
    }
    this.setUploaderQueueLimit();
    this.dataSource.next(this.uploader.queue);
    if ((this.data?.data?.setMaxLimit || this.options?.setMaxLimit) && this.preview_data.length - 1 !== this.companyPolicy?.attachments?.max_no_of_attachments) {
      this.disableUpload = false;
    } else if(this.preview_data?.length !== 0) {
      this.disableUpload = true;
    }
  }

  getPreviewData(): void {
    let serviceMethod: BehaviorSubject<any[]>;
    if(this.fileUploadedFor === 'NOTE'){
      serviceMethod = this._FileUploaderService.notesPreviewFiles;
    }else if(this.fileUploadedFor === 'ATTACHMENT'){
      serviceMethod = this._FileUploaderService.previewFiles;
    }
    this.previewFileSubscription = serviceMethod.subscribe((res) => {
        this.preview_data = res;
        if (((this.data?.data?.setMaxLimit || this.options?.setMaxLimit) && (res.length === this.companyPolicy?.attachments?.max_no_of_attachments) && (this.options?.multiple || this.data?.data?.multiple)) || ((this.options?.multiple === false || this.data?.data?.multiple === false) && (this.preview_data.length === 1))) {
          this.disableUpload = true;
        } else {
          this.disableUpload = false;
        }
        this.setUploaderQueueLimit();
      }, (_err) => {
      });
  }

  removeFileFromCollection(removeFile: any, index: number): void {
    if (this.preview_data.length) {
      if (this?.uploader?.queue?.length > 0) {
        const old_count = this.preview_data_count;
        const remove_index = index - old_count;
        if (remove_index > -1) {
          this.uploader.queue[remove_index].remove();
          this.dataSource.next(this.uploader.queue);
        }
      }
      if ((this.data?.data?.setMaxLimit || this.options?.setMaxLimit) && this.preview_data.length - 1 === this.companyPolicy?.attachments?.max_no_of_attachments && this.preview_data?.length !== 0) {
        this.disableUpload = true;
      } else {
        this.disableUpload = false;
      }
      const removed_data = this.preview_data.filter(file => file.attachment_path === removeFile.attachment);
      this.preview_data = this.preview_data.filter(file => file.attachment_path !== removeFile.attachment);
      if (this.uploader?.queue?.length > 0) {
        this.preview_data_count = this.preview_data.length - this.uploader.queue.length;
      }
      if(this.fileUploadedFor === 'NOTE'){
        this._FileUploaderService.notesPreviewFiles.next(this.preview_data);
        this._FileUploaderService.removedNotesAttachments.next(removed_data);
        this._FileUploaderService.notesAttachments.next(this.preview_data);
      }else if(this.fileUploadedFor === 'ATTACHMENT'){
        this._FileUploaderService.previewFiles.next(this.preview_data);
        this._FileUploaderService.removedAttachments.next(removed_data);
        this._FileUploaderService.attachments.next(this.preview_data);
      }
    }
  }

  fileEventEmitHandler(event: any, index: number): void {
    if (event) {
      if (event.type === 'remove') {
        this.removeFileFromCollection(event.data, index);
      }
    }
  }

  ngOnDestroy(): void {
    if (this.previewFileSubscription?.unsubscribe) {
      this.previewFileSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    const fileFormatErrorMessage = this.translateService.instant('file_format.not_supported.text');
    if (this.options) {
      this.data = {
        extraClass: 'file-uploader',
        data: this.options
      };
    }
    if (this.data?.data?.url && this.data?.data?.params) {
      const urlParams: any = this._utilityService.constructParam(this.data?.data?.params);
      this.upload_url = `${this.data.data.url}?${urlParams}`;
    }

    if( this.data?.data?.uploadFileFor || this.options?.uploadFileFor){
      this.fileUploadedFor = this.data.data.uploadFileFor || this.options.uploadFileFor;
    }

    this.selectedVisibilityDropdown = this.data?.data?.showVisibilityIcon ? true : false;

    const allowedFileType: string[] = this.data?.data?.allowFileTypes || this.allowed_file_type;
    const fileUploaderOptions: FileUploaderOptions = {
      url: this.upload_url,
      disableMultipart: false,
      itemAlias: 'attachment',
      autoUpload: true,
      parametersBeforeFiles: true,
      allowedFileType: allowedFileType,
      additionalParameter: {
        'attachment_type': this.data.data.attachmentType,
        'module': this.data.data?.module || '',
        'module_uid': this.data.data?.moduleUid || ''
      },
      authToken: `Bearer ${localStorage.getItem('auth_token')}`,
      maxFileSize: 1000000 * (this.companyPolicy?.attachments?.max_attachment_size ?? 0)
    };
    if (allowedFileType?.length) {
      fileUploaderOptions['allowedMimeType'] = this._FileUploaderService.getAllowedMimeType(allowedFileType);
    }
    this.uploader = new FileUploader(fileUploaderOptions);

    /** Only files with supported extensions are permitted for upload.**/
    this.uploader.onAfterAddingFile = (fileItem: any) => {
      const extension = this._utilityService.getAttachmentExtension(fileItem.file.name)?.toLowerCase();
      if(!this._utilityService.supportedExtensions.includes(extension)){
        const content: string = fileItem?.file?.name + ' - ' + fileFormatErrorMessage;
        this._toast.error(content);
        fileItem.remove();
      }
    };

    this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any) => {
      if (filter.name === 'fileSize') {
        const content: string = item.name + ' ' + this._utilityService.getLocaleValue('maximum.file.size.message', 'exceeds the maximum allowed size');
        this._toast.error(content);
      } else if (filter.name === 'mimeType') {
        const content: string = item.name + ' - ' + fileFormatErrorMessage;
        this._toast.error(content);
      }
    };

    this.response = '';
    this.final_response = [];
    this.uploader.response.subscribe((res) => {
      if (res) {
        this.response = JSON.parse(res);
        if (this.response.type === 'success') {
          this.response.data.attachment_name = this.file_name;
          this.final_response.push(this.response.data);
          if (this.response?.data) {
            if (this.selectedVisibilityDropdown) {
              this.response.data.visible_to_customer = this.selectedUserVisibility ?? false;
            }
            this.preview_data.push(this.response.data);
          }
          if (this.response?.message) {
            this._toast.success(this.response.message);
          }
        }
        if(this.response.type === 'error'){
          this._toast.error(this.response.message);
        }
      }
      if (this.uploader.progress === 100) {
        if(this.fileUploadedFor === 'NOTE'){
          this._FileUploaderService.notesPreviewFiles.next(this.preview_data);
          this._FileUploaderService.notesAttachments.next(this.preview_data);
        }else if(this.fileUploadedFor === 'ATTACHMENT'){
          this._FileUploaderService.previewFiles.next(this.preview_data);
          this._FileUploaderService.attachments.next(this.preview_data);
        }
        this._FileUploaderService.onUploadFinished.next(this.final_response);
        this.final_response = [];
      }
    }, (err) => {
      const data = {
        message: 'Error occurred',
        error: err
      };
      this._FileUploaderService.onUploadError.next(data);
    });

    this.uploader.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
      this.file_name = item._file.name;
    };
    this.getPreviewData();
  }

  setUploaderQueueLimit(): void {
    if (this.data?.data?.setMaxLimit) {
      let availableLength: number = this.companyPolicy?.attachments?.max_no_of_attachments ?? 0;
      if (!this.data?.data?.multiple) {
        availableLength = 1;
      } else if (this.uploader?.queue?.length !== this.preview_data?.length && this.preview_data?.length) {
        availableLength = availableLength - this.preview_data?.length > 0 ? availableLength - this.preview_data?.length : 0;
      }
      this.uploader.options.queueLimit = availableLength;
    } else if (!this.data?.data?.multiple) {
      this.uploader.options.queueLimit = 1;
    }
  }

  onVisibilityChange(selectedUserVisibility: boolean): void {
    this.preview_data.forEach(data => {
      if ('visible_to_customer' in data) {
        data.visible_to_customer = selectedUserVisibility;
      } else {
        data['visible_to_customer'] = selectedUserVisibility;
      }
    });
  }

}
